/**
 * Analytics tracking for Grupo Babilonia
 * Sends page views and sponsor clicks to the backend API.
 */

// In development, Flask runs on localhost:5000
// In production, it's proxied through Nginx at the same domain
const API_BASE = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:5000/api'

/**
 * Track a page view
 * @param {string} pagePath - The route path (e.g., '/', '/cartelera')
 */
export function trackPageView(pagePath) {
  fetch(`${API_BASE}/track/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      page_path: pagePath,
      referrer: document.referrer || ''
    })
  }).catch(() => {
    // Silently fail - analytics should never break the site
  })
}

/**
 * Track a sponsor click
 * @param {number} sponsorId - The sponsor's database ID
 * @param {string} pagePath - The current page path
 */
export function trackSponsorClick(sponsorId, pagePath) {
  fetch(`${API_BASE}/track/sponsor-click`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sponsor_id: sponsorId,
      page_path: pagePath,
      referrer: document.referrer || ''
    })
  }).catch(() => {
    // Silently fail
  })
}
